import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../components/layout/Layout";

const Page = () => {
  return (
    <Layout title="ANVA Files">
      <Outlet />
    </Layout>
  );
};

export default Page;
